import React from 'react';
import { Button } from 'rsuite';
import RsModal from '@/widgets/components/rs-modal';
import RsModalBody from '@/widgets/components/rs-modal-body';
import RsModalFooter from '@/widgets/components/rs-modal-footer';
import RsModalHeader from '@/widgets/components/rs-modal-header';
import styled from 'styled-components';

const StyledRsModalHeader = styled(RsModalHeader)`
  font-size: 20px;
`;

const StyledRsModalBody = styled(RsModalBody)`
  padding: 0;
  margin: 20px 0;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

interface CancelInspectionsModalProps {
  open: boolean;
  propertyAddress: string;
  onClose: () => void;
  onAccept: () => void;
}

export function CancelInspectionsModal({
  open,
  onClose,
  onAccept,
  propertyAddress,
}: CancelInspectionsModalProps) {
  return (
    <RsModal open={open} onClose={onClose}>
      <StyledRsModalHeader>
        Cancel inspection for {propertyAddress}
      </StyledRsModalHeader>
      <StyledRsModalBody>
        Please confirm you want to cancel this inspection.
      </StyledRsModalBody>
      <RsModalFooter>
        <ButtonsWrapper>
          <Button onClick={onAccept} appearance="primary">
            Confirm Cancelation
          </Button>
          <Button appearance="ghost" onClick={onClose}>
            Close
          </Button>
        </ButtonsWrapper>
      </RsModalFooter>
    </RsModal>
  );
}
